/** Storage can be missing or throw on access (blocked site data, some private windows). */
export function localStorageOrNull(): Storage | null {
  try {
    return window.localStorage
  } catch {
    return null
  }
}
